module.exports = __webpack_public_path__ + "static/media/level2-off.bd7eb22e.svg";